import { StateService } from '../';

export class MenuState {
	public filter	= 'filter';
	public legend	= 'legend';
	public more		= 'search';

  constructor(private stateService: StateService) {
    this.more = this.stateService.mobile ? 'search' : 'more';
  }

	update(state: string): MenuState {
    let button4 = this.stateService.mobile ? 'search' : 'more';

		this.filter	= state === 'filter'	? 'map' : 'filter';
		this.legend	= state === 'legend'  ? 'map' : 'legend';
		this.more		= (state === button4 || state === 'about' || state === 'terms')   ? 'map' : button4;

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/state/menuState.ts